import { createElement } from 'react';
import { node, string } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Text/styled.js';
import '../Text/index.js';
import { CardTitle as CardTitle$1 } from './styled.js';

var CardTitle = function CardTitle(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(CardTitle$1, props, children);
};

var cardTitlePropTypes = {
  children: node.isRequired,
  className: string
};
CardTitle.propTypes = cardTitlePropTypes;
var cardTitleDefaultProps = {
  className: undefined
};
CardTitle.defaultProps = cardTitleDefaultProps;
var C = CardTitle;
export default C;
export { CardTitle, cardTitleDefaultProps, cardTitlePropTypes };